import React from "react";
import CustomRoute from "../../../hoc/CustomRoute";
import {Switch} from "react-router-dom";

function MyCourses(props) {

    return (
        <div className={"p-3"}>
        <Switch>
            {props.routes.map((route, index) => {
                return CustomRoute(route,index);
            })}
        </Switch>
        </div>
    );

}

export default MyCourses;